export const algoliaIntegrationAdapter = ({
  title,
  photo,
  description,
  slug,
  isExternal,
  externalLink,
}) => {
  return {
    logo: photo ? { alt: title, media: { url: photo } } : null,
    title,
    description: description || null,
    link: isExternal
      ? {
          href: externalLink,
        }
      : {
          href: `/integrations/${slug}`,
        },
  }
}

export const algoliaIntegrationsAdapter = (integrations) => {
  return integrations.map((integration) =>
    algoliaIntegrationAdapter(integration)
  )
}
